module.exports = __webpack_public_path__ + "img/partner_logo09.8543efea.png";